import React from 'react'

const Loader: React.FC = () => {
  return (
    <div className='container my-5'>
      <div className='text-center py-5'>
        <div className='spinner-border text-primary' role='status'>
          <span className='sr-only'>Ładowanie...</span>
        </div>
      </div>
    </div>
  )
}

export default Loader
